/*
 *问题库配置
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import { ListQuestionReq, QuestionReq, Question, VerifyInfoItem, ListQuestionAssociatedItemReq, ListQuestionParameterReq, ListQuestionDisplayReq, QuestionDisplayReq, QuestionDisplay } from "@/pbjs/xcommon/ticket_pb";
import { Page } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";

import InnerRequest from "./request";

export interface Options {
    Page: Page;
    QpType?: string; //问题类型
    Value?: string; //问题
    status?: string; //问题
    appname?: string
}

export interface delOptions {
    id?: number,
    qptype?: string;
    desc?: string;
    value?: string;
    options?: string;
    optionsdisplay?: string;
    status?: number,
    opuid?: string;
    utime?: string,
    opname?: string;
    associatedItemsList?: any;
    questionkey?: string;
    defaultNormal:boolean;
    appname?: string
}
export interface saveOptions {
    id?: number,
    qptype?: string;
    questionsnum?: number; //问题数量
    displaynum?: number; //展示数量
    display?: string;//展示类型
    itemid?: number; //工单类型
    questions?: string; //问题IDs 
    status?: number;
    opuid?: number;
    utime?: number;
    floatinfo?: string;
    opname?: string;//操作人
    loantype?: number;//贷款类型
    idverify?: number;//实名审核
    appname?: string
}

export function getListQuestionReq(arg: Options) {
    let request: any = new ListQuestionReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setQptype(arg.QpType);
    request.setValue(arg.Value);
    request.setAppname(arg.appname);
    return request;
}
//  根据筛选项，获取问题库配置列表和问题库规则展示问题
export const getListQuestionRequest = new InnerRequest(
    ticketClient,
    ticketClient.listQuestion
);

export function getDelQuestionReq(arg: delOptions) {
    // return new Promise((resolve, reject) => {
    //     (async () => {
    let request: any = new QuestionReq();
    let requestAuto: any = new Question();
    let req: any = new VerifyInfoItem();

    let associatedItemsList: any[] = [];
    arg.associatedItemsList.forEach((item: any) => {
        let req = new VerifyInfoItem();
        req.setVerifyinfoid(item.verifyinfoid);
        req.setName(item.name);
        associatedItemsList.push(req);
    });
    requestAuto.setAssociateditemsList(associatedItemsList);
    requestAuto.setId(arg.id);
    requestAuto.setQptype(arg.qptype);
    requestAuto.setDesc(arg.desc);
    requestAuto.setValue(arg.value);
    requestAuto.setOptions(arg.options);
    requestAuto.setOptionsdisplay(arg.optionsdisplay);
    requestAuto.setStatus(arg.status);
    requestAuto.setOpuid(arg.opuid);
    requestAuto.setUtime(arg.utime);
    requestAuto.setOpname(arg.opname);
    
    request.setData(requestAuto);
    return request;
}
export const getDelQuestionRequest = new InnerRequest(
    ticketClient,
    ticketClient.delQuestion
);

export function getSaveQuestionReq(arg: delOptions) {
    let request: any = new QuestionReq();
    let requestAuto: any = new Question();
    let req: any = new VerifyInfoItem();

    let associatedItemsList: any[] = [];
    arg.associatedItemsList.forEach((item: any) => {
        let req = new VerifyInfoItem();
        req.setVerifyinfoid(item.verifyinfoid);
        req.setName(item.name);
        associatedItemsList.push(req);
    });

    requestAuto.setAssociateditemsList(associatedItemsList);
    requestAuto.setId(arg.id);
    requestAuto.setQptype(arg.qptype);
    requestAuto.setValue(arg.value);
    requestAuto.setOptions(arg.options);
    requestAuto.setQuestionkey(arg.questionkey);
    requestAuto.setDefaultnormal(arg.defaultNormal)
    requestAuto.setAppname(arg.appname);
    request.setData(requestAuto);
    return request;
}
//  保存
export const getSaveQuestionRequest = new InnerRequest(
    ticketClient,
    ticketClient.saveQuestion
);
export function getEditSaveQuestionReq(arg: delOptions) {
    let request: any = new QuestionReq();
    let requestAuto: any = new Question();
    let req: any = new VerifyInfoItem();

    let associatedItemsList: any[] = [];
    arg.associatedItemsList.forEach((item: any) => {
        let req = new VerifyInfoItem();
        req.setVerifyinfoid(item.verifyinfoid);
        req.setName(item.name);
        associatedItemsList.push(req);
    });
    requestAuto.setAssociateditemsList(associatedItemsList);
    requestAuto.setId(arg.id);
    requestAuto.setQptype(arg.qptype);
    requestAuto.setValue(arg.value);
    requestAuto.setOptions(arg.options);
    requestAuto.setQuestionkey(arg.questionkey);
    request.setData(requestAuto);
    requestAuto.setDefaultnormal(arg.defaultNormal)
    requestAuto.setAppname(arg.appname)
    return request;
}
//  问题库配置编辑报存
export const getEditSaveQuestionRequest = new InnerRequest(
    ticketClient,
    ticketClient.editQuestion
);
// 问题规则报存 和 有效无效
export function getSaveQuestionDisplayReq(arg: saveOptions) {
    let request: any = new QuestionDisplayReq();
    let requestAuto: any = new QuestionDisplay();
    requestAuto.setId(arg.id);
    requestAuto.setQptype(arg.qptype);
    requestAuto.setQuestionsnum(arg.questionsnum); // 问题数量
    requestAuto.setDisplaynum(arg.displaynum); // 展示数量
    requestAuto.setDisplay(arg.display); // 展示数量
    requestAuto.setItemid(arg.itemid); // 工单类型 num
    requestAuto.setQuestions(arg.questions); //问题IDs 
    requestAuto.setStatus(arg.status);
    requestAuto.setOpuid(arg.opuid);
    requestAuto.setUtime(arg.utime);
    requestAuto.setFloatinfo(arg.floatinfo);
    requestAuto.setOpname(arg.opname); //操作人
    requestAuto.setLoantype(arg.loantype); //贷款类型
    requestAuto.setIdverify(arg.idverify); //实名审核
    requestAuto.setAppname(arg.appname);
    request.setData(requestAuto);
    return request;
}
export const getSaveQuestionDisplayRequest = new InnerRequest(
    ticketClient,
    ticketClient.saveQuestionDisplay
);
export const getSaveQuestionDisplayCheckRequest = new InnerRequest(
    ticketClient,
    ticketClient.saveQuestionDisplayCheck
);
// 选项列表
export function getListQuestionParameterReq(arg: Options) {
    let request: any = new ListQuestionParameterReq();
    request.setQptype(arg.QpType);
    request.setStatus(arg.status);
    return request;
}
export const getListQuestionParameteRequest = new InnerRequest(
    ticketClient,
    ticketClient.listQuestionParameter
);
// 信息关联
export function getQuestionAssociatedItemReq() {
    let request: any = new ListQuestionAssociatedItemReq();
    return request;
}
export const getQuestionAssociatedItemRequest = new InnerRequest(
    ticketClient,
    ticketClient.listQuestionAssociatedItem
);

// 问题库展示规则列表
export function getListQuestionDisplayReq(arg: Options) {
    let request: any = new ListQuestionReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setQptype(arg.QpType);
    request.setValue(arg.Value);
    request.setAppname(arg.appname)
    return request;
}
//  根据筛选项，获取问题库展示规则列表
export const getListQuestionDisplayRequest = new InnerRequest(
    ticketClient,
    ticketClient.listQuestionDisplay
);
